import React, { useState, useEffect, useRef } from 'react';

// Generic multi-select dropdown (checkboxes) — extracted out of MatchChronic.js (2026-07-28) so
// the Full Physical Report's match picker can reuse the exact same control instead of a second
// hand-built copy. Behavior unchanged from the original.
export default function MultiSelect({ options, selected, onChange, placeholder }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(() => {
    const h = e => { if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const toggle = val => onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
  const buttonLabel = selected.length === 0
    ? (placeholder || 'All matches')
    : selected.length === 1
      ? (options.find(o => o.value === selected[0])?.label ?? selected[0])
      : `${selected.length} matches`;
  return (
    <div ref={rootRef} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(o => !o)} style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px 7px 12px',
        borderRadius: 8, border: `1px solid ${selected.length > 0 ? '#3b82f6' : 'var(--border-strong)'}`,
        background: selected.length > 0 ? 'rgba(59,130,246,0.1)' : 'var(--bg-card)',
        color: selected.length > 0 ? '#93c5fd' : 'var(--text-primary)',
        fontSize: '0.84rem', fontFamily: 'inherit', cursor: 'pointer', outline: 'none', minWidth: 200,
      }}>
        <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{buttonLabel}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: '0.15s', flexShrink: 0 }}>
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 300,
          background: 'var(--bg-card)', border: '1px solid var(--border-strong)', borderRadius: 10,
          minWidth: 240, maxHeight: 300, overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.5)', padding: '5px 0' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', cursor: 'pointer',
            fontSize: '0.82rem', color: 'var(--text-primary)',
            background: selected.length === 0 ? 'rgba(59,130,246,0.07)' : 'transparent' }}>
            <input type="checkbox" checked={selected.length === 0} onChange={() => onChange([])} style={{ accentColor: '#3b82f6', flexShrink: 0 }} />
            All matches
          </label>
          <div style={{ height: 1, background: 'var(--border)', margin: '3px 0' }} />
          {options.map(opt => (
            <label key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', cursor: 'pointer',
              fontSize: '0.82rem', color: 'var(--text-primary)',
              background: selected.includes(opt.value) ? 'rgba(59,130,246,0.07)' : 'transparent' }}>
              <input type="checkbox" checked={selected.includes(opt.value)} onChange={() => toggle(opt.value)} style={{ accentColor: '#3b82f6', flexShrink: 0 }} />
              {opt.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
